"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const assets_1 = require("~/assets");
const CloseButton_scss_1 = __importDefault(require("./CloseButton.scss"));
function CloseButton({ onCLickHandler }) {
    return (react_1.default.createElement("button", { type: "button", className: CloseButton_scss_1.default.close, "data-dismiss": "modal", "aria-label": "Close", onClick: onCLickHandler },
        react_1.default.createElement("img", { src: assets_1.svgSystemClose, alt: "Close button" })));
}
exports.default = CloseButton;
